import React from 'react';
import { Grid, GridColumn, GridNoRecords } from '@progress/kendo-react-grid';

import HeaderCell from '../../../documents/components/cells/headerCell/headerCell';
import AgreementCell from '../cells/agreementCell/agreementCell';
import useTranslate from '../../../../common/hooks/useTranslate';

import '@progress/kendo-theme-default/dist/all.css';
import '../../../ui/table/table.scss';
import './agreementsTable.scss';

const AgreementTable = ({ agreements }) => {
  const { t } = useTranslate();

  return (
    <div className={'table agreements-table'}>
      <Grid data={agreements} sortable={true} total={agreements && agreements.length} selectedField="selected" scrollable={'scrollable'}>
        <GridNoRecords>{t('AGREEMENTS.NO_DOCUMENTS')}</GridNoRecords>
        <GridColumn field="name" className="tableCell" cell={AgreementCell} headerCell={HeaderCell} />
      </Grid>
    </div>
  );
};

export default AgreementTable;
